import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationFlowEntity } from './outreach-automation-flow.entity';
import { OutreachAutomationStepExecutionEntity } from './outreach-automation-step-execution.entity';

@Entity('_outreach_automation_execution')
export class OutreachAutomationExecutionEntity extends BaseEntity {
	@Column('int', { name: '_fk__client__id', unsigned: true })
	public fkClientId!: number;

	@Column('enum', {
		name: '_execution_status',
		enum: ['active', 'completed', 'failed', 'paused'],
	})
	public executionStatus!: 'active' | 'completed' | 'failed' | 'paused';

	@Column('timestamp', {
		name: '_started_at',
		default: () => 'CURRENT_TIMESTAMP',
	})
	public startedAt!: Date;

	@Column('timestamp', { name: '_completed_at', nullable: true })
	public completedAt!: Date | null;

	@Column('int', { name: '_current_step_id', nullable: true, unsigned: true })
	public currentStepId!: number | null;

	@Column('json', { name: '_context_data', nullable: true })
	public contextData!: object | null;

	@Column('text', { name: '_error_message', nullable: true })
	public errorMessage!: string | null;

	@ManyToOne(
		() => OutreachAutomationFlowEntity,
		(outreachAutomationFlow) =>
			outreachAutomationFlow.outreachAutomationExecutions,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_automation_flow__id', referencedColumnName: 'id' },
	])
	public fkOutreachAutomationFlow!: OutreachAutomationFlowEntity;

	@OneToMany(
		() => OutreachAutomationStepExecutionEntity,
		(outreachAutomationStepExecution) =>
			outreachAutomationStepExecution.fkOutreachAutomationExecution,
		{},
	)
	public outreachAutomationStepExecutions!: Array<OutreachAutomationStepExecutionEntity>;
}
